var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor3",attrs:{"id":"editor3","className":"editor3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }